
      let Page = require('/work/ios-sdk/src/pages/search/guides/address-autofill.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Address Autofill",
    "description": "Mobile Form Autofill for iOS Search SDK.",
    "contentType": "guide",
    "layout": "page",
    "tag": "new",
    "order": 3,
    "language": [
      "Swift"
    ],
    "products": [
      "Search SDK for iOS"
    ],
    "prependJs": [
      "import videoAutofill from '../../../video/search-autofill-demo-ios.mp4'",
      "import IphoneFrame from '../../../components/iphone-frame';",
      "import RelatedPage from '@mapbox/dr-ui/related-page';",
      "import Note from '@mapbox/dr-ui/note';"
    ]
  }
}
      };
    